<homey-page-title-layout>Bianca’s story</homey-page-title-layout>
<div class="flex flex-col justify-center items-center pt-4">
  <img class="rounded-full size-32" src="/assets/landing-page/reviews/bianca.webp" alt="">
  <p class="quote mt-4 max-w-sm text-center">“I'm so happy! I can't believe I got selected for the housing lottery!
    Now I see a future in NYC because my housing just got affordable!”</p>
  <p>— Bianca, Brooklyn</p>
</div>

<div class="space-y-8 mt-16">
  <p>When Bianca first moved to Brooklyn, she loved the city — but rent kept taking more of her paycheck. Even with a good job, the idea of staying long-term felt out of reach. Starting a family here? Almost impossible.</p>
  <p>She had heard about the NYC Housing Lottery, but like many New Yorkers, she didn’t know where to start.</p>
  <p><span class="quote">“I just didn’t think it would happen for me,”</span> she said.</p>
  <p>That’s when she started using Homey.</p>
  <p>She set up her profile, by giving some basic info about herself, and within 10 minutes, Homey was automatically applying her to every lottery she qualified for.</p>
  <p class="quote">“I loved that I could just create my profile and they handled everything. I didn’t have to worry about missing something.”</p>
  <p>Then the text message came.</p>
  <p class="quote">“I’m so happy! I can’t believe I got selected for the housing lottery! Now I see a future in NYC because my housing just got affordable.”</p>
</div>

<div class="flex justify-center mt-8">
  <homey-signup-button signupText="Claim your free trial"/>
</div>
